import { useRef, useState } from "react";
import { loadSimmplifyScripts } from "../helper/simplify-script";
import { useWallet } from "./useWallet";
import {ApiCall} from "../helper/axios";

export const useSimlifyPayment = (totalPrice, onSuccessfulPayment, getLoyaltyAmount = null) => {
  const payloadRef = useRef(null);
  const { debit, credit, loading: walletLoading } = useWallet();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addOnlinePaymentListner = async () => {
    try {
      setLoading(true);
      const added = await loadSimmplifyScripts();
      if (added) {
        addListner();
      } else {
        setError("Failed to load payment scripts");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error loading payment scripts:", error);
      setError("Failed to load payment scripts");
      setLoading(false);
    }
  };

  const addListner = () => {
    try {
      window.SimplifyCommerce.hostedPayments(
        async (response) => {
          if (response?.close) {
            setLoading(false);
            return;
          }

          if (response?.data?.paymentStatus === "APPROVED") {
            if (response.data.id) {
              let errorMessage;
              let actualError;
              let customError = false;
              try {
                setLoading(true);
                setError(null);

                const deductBalanceFromWallet = await debit(
                  totalPrice,
                  payloadRef.current?.name,
                  "online"
                );

                if (
                  deductBalanceFromWallet?.status === 200 &&
                  deductBalanceFromWallet?.data?.success &&
                  deductBalanceFromWallet?.data?.transaction_id
                ) {
                  const loyaltyAmount = getLoyaltyAmount ? getLoyaltyAmount() : null;
                  const confirmResponse = await onSuccessfulPayment(
                    payloadRef.current,
                    loyaltyAmount
                  );

                  if (confirmResponse?.data?.bookingReference) {
                    payloadRef.current = null;
                    const closeBtn = document?.querySelector?.(".checkout-single .close-btn");
                    if (closeBtn) {
                      closeBtn.click();
                    }
                    return confirmResponse?.data?.bookingReference;
                  } else {
                    actualError = confirmResponse;
                    errorMessage = confirmResponse?.message ||
                        confirmResponse?.data?.message ||
                        confirmResponse?.data?.data?.error_message ||
                        "If your payment has been debited, but the ticket is not yet confirmed. Please do not attempt to book again. Contact the admin for assistance with your ticket."
                    if(errorMessage === 'If your payment has been debited, but the ticket is not yet confirmed. Please do not attempt to book again. Contact the admin for assistance with your ticket.'){
                      customError = true;
                    }
                    throw new Error(
                        errorMessage
                    );
                  }
                } else {
                  throw new Error("Failed to process wallet transaction");
                }
              } catch (error) {
                await ApiCall("POST", '/generate-error', { error, errorMessage,actualError });
                if(customError){
                  const elementForBtn = document.querySelectorAll('.excursion-book-btn-hide');
                  if(elementForBtn?.length){
                    elementForBtn.forEach(el => {
                      el.style.setProperty('display', 'none', 'important');
                    });
                  }
                }
                await credit(totalPrice, payloadRef.current?.name, "online",customError);
                setError(error?.message || "Payment processing failed");
              } finally {
                payloadRef.current = null;
                setLoading(false);
              }
            }
          } else if (response?.data?.paymentStatus === "DECLINED" || response?.data?.paymentStatus === "FAILED") {
            setError("Payment was declined or failed. Please try again.");
            setLoading(false);
          }
        },
        {
          amount: (totalPrice ?? 1) * 100,
          currency: "AED",
        }
      ).closeOnCompletion(() => {
        setLoading(false);
      });
    } catch (error) {
      console.error("Error setting up payment listener:", error);
      setError("Failed to setup payment system");
      setLoading(false);
    }
  };

  // Cleanup function to reset states
  const resetStates = () => {
    setLoading(false);
    setError(null);
    payloadRef.current = null;
  };

  return {
    loading: loading || walletLoading,
    payloadRef,
    error,
    addListner: addOnlinePaymentListner, // Changed to call the async function
    resetStates,
  };
};
